import { ChangeDetectionStrategy, Component, computed, OnInit, Signal, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { PostItem } from '@app/core/models';
import { CardForbiddenComponent } from '@app/layouts/components/card-forbidden/card-forbidden.component';
import { SHARED_MODULES } from '@app/shared';
import { GuardValidators } from '@app/shared/validations';
import { AppSelectors } from '@app/store';
import { Postable } from '../../utils/postable';
import { HeaderPostComponent } from '../header-post/header-post.component';
import { ItemPostComponent } from '../item-post/item-post.component';
import { PostJumbotronComponent } from '../post-jumbotron/post-jumbotron.component';
import { PostsFilterBarComponent } from '../posts-filter-bar/posts-filter-bar.component';
import { AnnouncementFilter, AnnouncementHeader } from './announcement';

export enum AnnouncementTypeEnum {
  Sent = 'sent',
  Received = 'received',
}
@Component({
  selector: 'app-post-announcement',
  imports: [
    SHARED_MODULES,
    HeaderPostComponent,
    ItemPostComponent,
    PostJumbotronComponent,
    CardForbiddenComponent,
    PostsFilterBarComponent,
  ],
  templateUrl: './post-announcement.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PostAnnouncementComponent extends Postable<PostItem> implements OnInit {
  protected readonly data: Signal<PostItem[]>;
  protected readonly type = AnnouncementTypeEnum;
  protected readonly filter = AnnouncementFilter;
  protected override header = AnnouncementHeader;
  protected override readonly guards = signal<any>([GuardValidators.Entity]);
  protected readonly filterType = signal<AnnouncementTypeEnum>(AnnouncementTypeEnum.Sent);

  constructor() {
    super();
    this.data = computed(() =>
      this.items().map((item) => ({
        ...item,
        items: item.items.map((subItem) => ({ ...subItem, filter: this.filterType() })),
      })),
    );
  }

  public override ngOnInit() {
    super.ngOnInit();
    this.store
      .select(AppSelectors.isAllow([20, 41]))
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((isAllow) => this.onFilterType(isAllow ? AnnouncementTypeEnum.Sent : AnnouncementTypeEnum.Received));
  }

  public onFilterType(type: AnnouncementTypeEnum) {
    this.filterType.set(type);
    this.onFilter({ sent: type === AnnouncementTypeEnum.Sent ? 1 : 0 });
  }
}
